const DEFAULT_PERFECT_SCROLLBAR_CONFIG = {
    suppressScrollX: true
};
const ɵ0 = DEFAULT_PERFECT_SCROLLBAR_CONFIG;
export class SharedModule {
}
export { ɵ0 };
